module.exports = __webpack_public_path__ + "img/product28802.da51c983.png";